export interface CustomAppBandwidthAccess {
  isOwner?: boolean;
  isAdmin?: boolean;
}

export function canReadCustomAppBandwidthBudget(
  information: CustomAppBandwidthAccess | null | undefined
): boolean {
  return !!(information?.isOwner || information?.isAdmin);
}

export function canManageCustomAppBandwidthBudget(
  information: CustomAppBandwidthAccess | null | undefined
): boolean {
  return !!information?.isOwner;
}

export function shouldLoadCustomAppCurrentBandwidthUsage(
  information: CustomAppBandwidthAccess | null | undefined
): boolean {
  return canManageCustomAppBandwidthBudget(information);
}
